/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Result update request
 * @export
 * @interface ResultUpdateRequest
 */
export interface ResultUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof ResultUpdateRequest
     */
    current?: number;
}

/**
 * Check if a given object implements the ResultUpdateRequest interface.
 */
export function instanceOfResultUpdateRequest(value: object): value is ResultUpdateRequest {
    return true;
}

export function ResultUpdateRequestFromJSON(json: any): ResultUpdateRequest {
    return ResultUpdateRequestFromJSONTyped(json, false);
}

export function ResultUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'current': json['current'] == null ? undefined : json['current'],
    };
}

export function ResultUpdateRequestToJSON(json: any): ResultUpdateRequest {
    return ResultUpdateRequestToJSONTyped(json, false);
}

export function ResultUpdateRequestToJSONTyped(value?: ResultUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'current': value['current'],
    };
}

